/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

import {InjectionToken} from '@angular/core';
import {AppSettingsRequestInterface} from '@shared/interface';

export const DEFAULT_APP_SETTINGS_CONFIG  = new InjectionToken<AppSettingsRequestInterface>('DEFAULT_APP_SETTINGS_CONFIG');
